module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns content is-centered is-gapless",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "column is-4 has-text-centered",
    staticStyle: {
      "font-weight": "lighter",
      "font-size": "0.8em"
    }
  }, [_c('span', {
    staticClass: "column-link",
    class: {
      'is-active': _vm.$route.name === 'landing'
    }
  }, [_c('a', {
    attrs: {
      "href": "/?anchor=gallery-container"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onScrollTo('landing', 'gallery-container')
      }
    }
  }, [_vm._v("\n            Gallery\n          ")])]), _vm._v("  |  \n        "), _c('span', {
    staticClass: "column-link",
    class: {
      'is-active': _vm.$route.name === 'about'
    }
  }, [_c('router-link', {
    attrs: {
      "href": "/about",
      "to": "about"
    }
  }, [_vm._v("About")])], 1), _vm._v("  |  \n        "), _c('span', {
    staticClass: "column-link",
    class: {
      'is-active': _vm.$route.name === 'locate'
    }
  }, [_c('router-link', {
    attrs: {
      "href": "/locate",
      "to": "locate"
    }
  }, [_vm._v("Locate")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "columns content is-centered is-gapless"
  }, [_c('p', {
    staticClass: "column is-4 has-text-centered",
    staticStyle: {
      "font-weight": "lighter"
    }
  }, [_vm._v("\n        © " + _vm._s(_vm.year) + " Lasting Impressions Sdn Bhd (218733-H). All Rights Reserved.\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e856026","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 740
// module chunks = 1